import apiClient from '../api';

export const createFirstFifty = (data) => apiClient.post(`/first-fifty/create`, data);
export const verifyRecaptcha = (data) => apiClient.post(`/first-fifty/verify-recaptcha`, data);